module.exports = {
  name: 'default',
  vaultId: 'tntk0kyzrpw',
  environment: 'sandbox',
  endpoint: 'vgs-sandbox.sitecore.moweb-acc.com',
  wrapperClass: 'flex-grid-2-col gutter-md',
  fieldClass: 'input',
  css: {
    display: 'block',
    position: 'relative',
    'z-index': '2',
    width: '100%',
    height: '60px',
    'font-size': '16px',
    padding: '1.25em 0 .625em .625em',
    border: '1px solid #d8d8d8',
    color: '#676060',
    'box-sizing': 'border-box',
    'background-color': 'rgba(0,0,0,0)',
    'border-radius': '4px',
    transition: 'box-shadow .5s,border-color .25s ease-in-out',
    '&:focus': {
      border: '2px solid #7c797a',
      color: '#7c797a'
    },
    '&.invalid.touched': {
      border: '1px solid #b02909'
    },
    '@font-face': {
      'font-family': "Trade Gothic W01 Cn_18",
      src: 'url("/fonts/28a6da92-8a64-42a5-9565-914caf257538.woff2") format("woff2"), url("/fonts/6e6d9ee8-cbc5-4670-b243-c90a93b3a8d2.woff") format("woff")',
      'font-weight': '400',
      'font-style': 'normal',
    },
    '::placeholder': {
      'z-index': 2,
      'align-items': 'center',
      top: '20px',
      'margin-left': '10px',
      'font-weight': '400',
      color: '#676060',
      'font-size': '18px',
      'font-family': 'Trade Gothic W01 Cn_18,ArialNarrow,Arial-Narrow,Arial Narrow,Arial,sans-serif',
      transition: 'all .3s ease',
    },
    '[dir="rtl"] & ': {
      'padding-left': '3.625em',
    }
  },
  cssRtl: {
    unicodeBidi: 'embed',
    textAlign: 'right',
    display: 'block',
    position: 'relative',
    'z-index': '2',
    width: '100%',
    height: '60px',
    'font-size': '16px',
    padding: '1.25em .5em .625em 1.25em',
    border: '1px solid #d8d8d8',
    color: '#676060',
    'box-sizing': 'border-box',
    'background-color': 'rgba(0,0,0,0)',
    'border-radius': '4px',
    transition: 'box-shadow .5s,border-color .25s ease-in-out',
    '&:focus': {
      border: '2px solid #7c797a',
      color: '#7c797a'
    },
    '&.invalid.touched': {
      border: '1px solid #b02909'
    },
    '@font-face': {
      'font-family': "Trade Gothic W01 Cn_18",
      src: 'url("/fonts/28a6da92-8a64-42a5-9565-914caf257538.woff2") format("woff2"), url("/fonts/6e6d9ee8-cbc5-4670-b243-c90a93b3a8d2.woff") format("woff")',
      'font-weight': '400',
      'font-style': 'normal',
    },
    '::placeholder': {
      'z-index': 2,
      'align-items': 'center',
      top: '20px',
      'margin-left': '10px',
      'font-weight': '400',
      color: '#676060',
      'font-size': '18px',
      'font-family': 'Trade Gothic W01 Cn_18,ArialNarrow,Arial-Narrow,Arial Narrow,Arial,sans-serif',
      transition: 'all .3s ease',
    }
  }
}
